module.exports = __webpack_public_path__ + "media/images/undraw_devices_re_dxae-6a929d59b5ab6dda16598f3b04d75675.svg";